import React from 'react';
import { CircleDashedIcon } from 'lucide-react';
export function PendingNote({
  children = 'Definition pending validation'
}: {
  children?: React.ReactNode;
}) {
  return <span className="inline-flex items-center gap-1 rounded border border-dashed border-caution/40 bg-caution-soft px-1.5 py-0.5 text-[11px] font-medium text-caution" data-id="element-736" data-mp="o2brulv9xy8n">
      <CircleDashedIcon className="h-3 w-3" aria-hidden data-id="element-737" data-mp="k1jhtqekvpbb" />
      {children}
    </span>;
}